export default __webpack_public_path__ + "static/media/happy_office.be250b2a.jpg";